import { ButtonType, DialogFooterButtonsWidget, TextFieldWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle, DialogTextFieldStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';

import { getCredentialEncryptionKeyRequest } from '../actions/GetCredentialEncryptionKeyRequestAction';
import { DeactivateSiteEncryptionDataKeyRequest, DeactivateSiteEncryptionDataKeyResult } from '../serverApi/requests/DeactivateSiteEncryptionDataKeyRequest';
import { deactivateSiteEncryptionKey } from '../services/CredentialEncryptionKeyService';


export interface KMSKeyDeactivateViewOwnProps {
    closeDialog: CloseAndDismiss;
    dataKeyId: string;
}

export interface KMSKeyDeactivateViewDispatchProps {
    retrieveCredentialEncryptionKey: () => void;
}

export type KMSKeyDeactivateViewProps = KMSKeyDeactivateViewOwnProps & KMSKeyDeactivateViewDispatchProps;


export interface KMSKeyDeactivateViewState {
    isDeactivatingKey: boolean;
    validationText: string;
}

export class KMSKeyDeactivateViewComponent extends React.PureComponent<KMSKeyDeactivateViewProps, KMSKeyDeactivateViewState> {

    constructor(props: KMSKeyDeactivateViewProps) {
        super(props);
        this.state = {
            isDeactivatingKey: false,
            validationText: '',
        };
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyDeactivateDialog_subtitle()}</div>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyDeactivateDialog_Description()}</div>
            <ul style={{paddingLeft: '20px'}}>
                <li id="kms-key-deactivate-terms-1">{Messages.credentialEncryption_KMSKeyDeactivateDialog_Bullet1()}</li>
                <li id="kms-key-deactivate-terms-2">{Messages.credentialEncryption_KMSKeyDeactivateDialog_Bullet2()}</li>
            </ul>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyDeactivateDialog_validation_message()}</div>
            <div style={DialogFieldParentStyle}>
                <TextFieldWidget
                    label={Messages.credentialEncryption_KMSKeyDeactivateDialog_validation_confirmation_label()}
                    testId="data-key-deactivate-validation-text"
                    value={this.state.validationText}
                    className={DialogTextFieldStyle}
                    onChange={(e) => this.setState({validationText: e.target.value})}
                />
            </div>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Destructive,
                            showSpinner: this.state.isDeactivatingKey,
                            children: Messages.credentialEncryption_KMSKeyDeactivateDialog_Deactivate_button(),
                            disabled: this.state.validationText !== Messages.credentialEncryption_KMSKeyDeactivateDialog_validation_confirmation_text(),
                            onClick: () => this.deactivateKey(),
                            testId: 'deactivate-button'
                        }
                    ]}
                />
            </div>
        </>;
    }

    private deactivateKey() {
        this.setState({isDeactivatingKey: true}, () => {
            deactivateSiteEncryptionKey(new DeactivateSiteEncryptionDataKeyRequest({dataKeyId: this.props.dataKeyId}))
            .then((response: DeactivateSiteEncryptionDataKeyResult) => {
                if(response?.errors && response.errors.length > 0){
                    ToasterService.instance.pop({ type: ToastType.Error, text: Messages.credentialEncryption_KMSKeyDeactivateDialog_FailureToast() });
                } else {
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.credentialEncryption_KMSKeyDeactivateDialog_SuccessToast() });
                    this.props.retrieveCredentialEncryptionKey();
                }
            }).catch(() => {
                ToasterService.instance.pop({ type: ToastType.Error, text: Messages.credentialEncryption_KMSKeyDeactivateDialog_FailureToast() });
            }).finally(() => {
                this.setState({isDeactivatingKey: false});
                this.props.closeDialog.close();
            });
        });
    }
}

const mapDispatchToProps: MapDispatchToProps<KMSKeyDeactivateViewDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveCredentialEncryptionKey: getCredentialEncryptionKeyRequest
  },
  dispatch);

export const KMSKeyDeactivateView: React.ComponentClass<KMSKeyDeactivateViewOwnProps> =
  connect(undefined, mapDispatchToProps)(KMSKeyDeactivateViewComponent);